
import vue, { defineComponent, nextTick, reactive, ref, toRefs, watch, computed, ComputedRef, createVNode, defineCustomElement } from 'vue'
import { useRoute } from 'vue-router'
import globalsets from '@/utils/globalsets'
// import HistogramSlider from 'vue3-histogram-slider'
// import 'vue3-histogram-slider/dist/histogram-slider.css'
import HistogramSlider from '@/assets/conditionstock/js/histogram-slider.common.js'
import type { PropType } from 'vue'
import type { ValueType, Option, HistogramType, Item } from './typings'

export default defineComponent({
  components: {
    HistogramSlider
  },
  props: {
    theme: {
      type: String,
      default: () => {
        return 'light'
      }
    },
    sliderData: {
      type: Object as PropType<HistogramType>
    },
    options: {
      type: Array,
      default() {
        return []
      }
    },
    unit: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: Object as PropType<ValueType>,
      default() {
        return {
          range: []
        }
      }
    }
  },
  setup(props: any, context: any) {
    type PageDataType = {
      from: number
      to: number
      max: number
      min: number
      data: number[] | null
      selectVal: number | null
      getPopupContainer: { (): Element | null }
      defaultValue?: ComputedRef<any>
    }
    const route = useRoute()
    const RefSlider = ref()
    const pageData: PageDataType = reactive({
      from: 0,
      to: 100,
      min: 0,
      max: 100,
      data: null,
      selectVal: null,
      getPopupContainer: () => document.querySelector('.ant-collapse')
      // defaultValue:{}
    })
    pageData.defaultValue = computed(() => {
      return props.defaultValue
    })
    const handlerData = (val: any) => {
      pageData.min = val.range[0]
      pageData.max = val.range[1]
      const valRange = (props.defaultValue || {}).range
      pageData.from = valRange && valRange.length && valRange[0] >= val.range[0] && valRange[0] <= val.range[1] ? valRange[0] : val.range[0]
      pageData.to =
        valRange && valRange.length && valRange[1] >= val.range[0] && valRange[1] >= pageData.from && valRange[1] <= val.range[1] ? valRange[1] : val.range[1]
      pageData.data = val.data
      nextTick(async () => {
        await RefSlider.value.reset()
        setTimeout(() => {
          RefSlider.value.update({ from: pageData.from, to: pageData.to })
        }, 200)
      })
    }

    let timer1: any = null
    const changeSlider = function (val: any) {
      if (timer1) clearTimeout(timer1)
      timer1 = setTimeout(() => {
        pageData.from = Math.round(val.from * 100) / 100
        pageData.to = Math.round(val.to * 100) / 100
        const result = {
          select1: props.options.find((item: Option) => item.value === pageData.selectVal),
          range: [pageData.from, pageData.to]
        }
        context.emit('changeVal', result)
      }, 300)
    }
    const changeSelect = function (val: Option) {
      const result: ValueType = {}
      result.select1 = props.options.find((item: Option) => item.value === val)
      if (val === -2) {
        handlerData(props.sliderData)
        result.range = [pageData.from, pageData.to]
      }
      context.emit('changeVal', result)
    }

    let timer: any
    const formatFrom = () => {
      if (isNaN(Number(pageData.from))) return pageData.min
      let from = pageData.from || pageData.min
      const max = pageData.to ? pageData.to : pageData.max
      if (pageData.from > max || pageData.from < pageData.min) {
        from = pageData.min
      }
      return Number(from)
    }
    const formatTo = () => {
      if (isNaN(Number(pageData.from))) return pageData.max
      let to = pageData.to || pageData.max
      const min = pageData.from ? pageData.from : pageData.min
      if (pageData.to < min || pageData.to > pageData.max) {
        to = pageData.max
      }
      return Number(to)
    }
    const filterNumberAndDot = (name: string) => {
      pageData[name] = globalsets.filterNumberAndDot(pageData[name])
      if (name === 'from') {
        pageData.from = formatFrom()
      } else {
        pageData.to = formatTo()
      }
    }
    const changeInput = function (key: string) {
      // if (timer) clearTimeout(timer)
      // timer = setTimeout(() => {
      filterNumberAndDot(key)
      RefSlider.value.update({ from: pageData.from, to: pageData.to })
      const result = {
        select1: props.options.find((item: Option) => item.value === pageData.selectVal),
        range: [pageData.from, pageData.to]
      }
      context.emit('changeVal', result)
      // }, 500)
    }
    const reset = () => {
      pageData.selectVal = -1
      const valRange = (props.sliderData || {}).range || []
      pageData.from = valRange[0]
      pageData.to = valRange[1]
    }

    watch(
      () => props.sliderData,
      (val) => {
        if (!val || !Object.keys(val).length) return
        if (val.range[0] === pageData.min && val.range[1] === pageData.max && pageData.data?.length === val.data.length) return
        if (props.options.length === 0 || pageData.selectVal === -2 || props.defaultValue.select1.value === -2) {
          // debugger
          handlerData(val)
        }
      },
      {
        deep: true,
        immediate: true
      }
    )
    watch(
      () => props.defaultValue,
      (val: any) => {
        if (!val.select1 && !val.range) {
          reset()
          return
        }
        if (val.select1 && (!val.range || !val.range.length)) {
          // 非自定义
          pageData.selectVal = val.select1.value
          return
        }
        // 默认值和当前展示的结果以一样，不重新渲染
        if ((!val.select1 || val.select1.value === pageData.selectVal) && val.range[0] === pageData.from && val.range[1] === pageData.to) return
        pageData.selectVal = val.select1 ? val.select1.value : null
        if (val.range && (pageData.from !== val.range[0] || pageData.to !== val.range[1])) {
          pageData.from = val.range[0]
          pageData.to = val.range[1]
          nextTick(() => {
            RefSlider.value && RefSlider.value.update({ from: pageData.from, to: pageData.to })
          })
          // handlerData(props.sliderData)
        }
        // if (val.select1) {
        // } else {
        //   pageData.selectVal = -1
        //   if (props.sliderData) {
        //     pageData.from = props.sliderData.range[0]
        //     pageData.to = props.sliderData.range[1]
        //     RefSlider.value && RefSlider.value.update({ from: pageData.from, to: pageData.to })
        //   }
        // }
      },
      {
        deep: true,
        immediate: true
      }
    )
    return {
      ...toRefs(pageData),
      changeSlider,
      changeInput,
      RefSlider,
      changeSelect,
      reset,
      filterNumberAndDot
    }
  }
})
